module.exports = __webpack_public_path__ + "static/media/landing.cfb7920b.png";